import Alpine from 'alpinejs';

Alpine.data(
  'inputDocument',
  (adminURL, name, userName, userId, action, postId) => ({
    adminURL,
    errors: [],
    loading: false,
    file: null,
    status: 'idle',

    changeField() {
      const input = this.$refs.input;

      this.file = input.files[0];

      this.status = 'set';
    },
    fillForm() {
      const form = document.querySelector('.wpcf7');
      const userNameInput = form.querySelector('input[name="user_name"]');
      userNameInput.value = userName;

      const documentNameInput = form.querySelector(
        'input[name="document_name"]'
      );
      documentNameInput.value = name;
    },

    submit() {
      this.status = 'loading';
      if (!this.file) return;

      const form = document.querySelector('.wpcf7-form');

      this.fillForm();

      const formData = new FormData();
      formData.append('action', action);
      formData.append('name', name);
      formData.append('user_name', userName);
      formData.append('file', this.file);
      formData.append('user_id', userId);

      if (postId) {
        formData.append('post_id', postId);
      }

      fetch(this.adminURL, {
        method: 'POST',
        body: formData,
      })
        .then((res) => res.json())
        .then((res) => {
          const urlInput = form.querySelector('input[name="url"]');
          if (urlInput) urlInput.value = res.url;

          const submitFormBtn = form.querySelector('.wpcf7-submit');
          submitFormBtn.click();

          this.status = 'success';

          this.$dispatch('refetch-documents');
        });
    },
  })
);
